import { Alert, ErrorAlert } from '../../../ui/feedback';
import { Timestamp, age } from '../../../ui/Timestamp';
import type { ImplDetail } from './types';
export function ImplementationStatus({ i, error }: { i: ImplDetail; error: unknown }) {
  return (
    <>
      {i.state === 'stale' && (
        <Alert tone="error" title="Stale owner — work writes are fenced">
          <span>
            No heartbeat since <Timestamp value={i.lastHeartbeatAt} /> (
            {i.lastHeartbeatAt ? age(i.lastHeartbeatAt) : 'never'}). The lease expired at{' '}
            <Timestamp value={i.leaseExpiresAt} />. Check the external workspace before recovering; the
            application cannot stop a process that still runs on {i.builder?.machineId ?? 'the builder'}.
          </span>
        </Alert>
      )}
      <ErrorAlert error={error} title="Readiness was refused" />
    </>
  );
}
